import React from 'react';
// Helpers
import { formatAudienceSize } from 'helpers/campaignEditModal';
import { getSocialMedia } from 'helpers/following';
// Types
import { GetCampaignOffers_getCampaignOffers_entities } from 'api/campaignV2/types/GetCampaignOffers';
import { SocialMediaType } from 'api/graphql-global-types';
// Styles
import styles from './Followers.module.scss';

type FollowersColumnProps = {
  row: GetCampaignOffers_getCampaignOffers_entities;
};

const Followers = ({ row }: FollowersColumnProps): JSX.Element => {
  const followers = getSocialMedia(row);

  const isInstagram = followers?.type === SocialMediaType.Instagram;
  const isTiktok = followers?.type === SocialMediaType.Tiktok;
  const isTwitter = followers?.type === SocialMediaType.Twitter;

  const platform = isInstagram
    ? 'Instagram'
    : isTiktok
    ? 'TikTok'
    : isTwitter
    ? 'X'
    : null;

  return (
    <div className={styles.root}>
      <p className={styles.audience}>
        <span className={styles.count}>
          {formatAudienceSize(followers?.followingCnt?.toString() ?? '', 1)}
        </span>

        {platform && <span className={styles.platform}>{platform}</span>}
      </p>

      {followers?.url && (
        <a
          href={followers.url}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}
        >
          View profile
        </a>
      )}
    </div>
  );
};

export default Followers;
